import { Component } from "react";

/**
 * Global ErrorBoundary — prevents the entire app from going to a black/blank
 * screen when a React child throws. Shows a friendly recovery UI instead so
 * users are never stuck.
 */
export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("[ErrorBoundary] Uncaught render error:", error, info);
  }

  handleReload = () => {
    // Full reload clears any orphaned overlays / pointer-events blockers.
    window.location.reload();
  };

  handleHome = () => {
    window.location.href = "/";
  };

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div
        data-testid="app-error-boundary"
        className="min-h-screen bg-[#0A0A0A] text-white flex items-center justify-center px-4"
      >
        <div className="max-w-md w-full bg-[#111] border border-[#262626] rounded-md p-8 text-center">
          <h1 className="font-display text-2xl mb-3">Algo salió mal</h1>
          <p className="text-neutral-400 text-sm mb-6">
            Ocurrió un error inesperado en la aplicación. Nada se dañó — solo
            recarga la página e intenta de nuevo.
          </p>
          <div className="flex flex-col gap-2">
            <button
              data-testid="error-boundary-reload"
              onClick={this.handleReload}
              className="w-full bg-[#EF4444] hover:bg-[#DC2626] text-white rounded-md h-10"
            >
              Recargar la página
            </button>
            <button
              data-testid="error-boundary-home"
              onClick={this.handleHome}
              className="w-full bg-transparent border border-[#262626] text-neutral-300 hover:text-white rounded-md h-10"
            >
              Ir al inicio
            </button>
          </div>
          {this.state.error?.message && (
            <p className="mt-4 text-[10px] text-neutral-600 break-all">
              {String(this.state.error.message).slice(0, 200)}
            </p>
          )}
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
